import FilterSearch from '../../_partials/filter-search/filter-search';

export default class Tags {
  constructor(form) {
    this.targetForm = form;
    this.tagsForm = document.querySelector('.tags__form');
  }
  init() {
    new FilterSearch(this.tagsForm);
  }
}